export default "__VITE_ASSET__3b72ff85__"